import { SearchSortByEnum } from '@orcha/types';
import { mapOrderByOptionsToSearchSortByEnum } from '@orcha/utils';
import { useSiteContext } from 'src/store';
import useTranslation from 'next-translate/useTranslation';

const GetTranslationForEnumValue = (enumValue: SearchSortByEnum) => {
  const { t } = useTranslation();
  switch (enumValue) {
    case SearchSortByEnum.RELEVANCE:
      return t('search:sortBy.relevance');
    case SearchSortByEnum.SCORE_DESCENDING:
      return t('search:sortBy.scoreDescending');
    case SearchSortByEnum.SCORE_ASCENDING:
      return t('search:sortBy.scoreAscending');
    case SearchSortByEnum.NAME_ASCENDING:
      return t('search:sortBy.nameAscending');
    case SearchSortByEnum.NAME_DESCENDING:
      return t('search:sortBy.nameDescending');
    default:
      return '';
  }
};

export const useSortByOptions = () => {
  const { searchConfig } = useSiteContext();
  const orderOptions = mapOrderByOptionsToSearchSortByEnum(searchConfig);

  return orderOptions?.map((option) => {
    return {
      enum: option,
      label: GetTranslationForEnumValue(option),
    };
  });
};
